import styled from '@emotion/styled';
import type { Confidence } from '@trinity/chat/types/extracted-answers.api';
import { Tooltip } from '../presentation/Tooltip';

const colorMap: Record<Confidence, { bg: string; fg: string }> = {
  high: { bg: '#e3f9e8', fg: '#2d7a2e' },
  medium: { bg: '#fffbeb', fg: '#92400e' },
  low: { bg: '#f5f5f5', fg: '#adadad' },
  not_found: { bg: '#fef2f2', fg: '#991b1b' },
};

const labelMap: Record<Confidence, string> = {
  high: 'High',
  medium: 'Medium',
  low: 'Low',
  not_found: 'Not Found',
};

const Badge = styled.span<{ bg: string; fg: string }>`
  display: inline-flex;
  align-items: center;
  padding: 2px 8px;
  border-radius: 12px;
  font-size: 12px;
  font-weight: 600;
  background: ${(p) => p.bg};
  color: ${(p) => p.fg};
`;

type Props = {
  confidence: Confidence;
  rationale?: string | null;
};

export function ConfidenceBadge({ confidence, rationale }: Props): React.ReactElement {
  const colors = colorMap[confidence];
  const badge = (
    <Badge bg={colors.bg} fg={colors.fg}>
      {labelMap[confidence]}
    </Badge>
  );

  if (!rationale) return badge;

  return (
    <Tooltip title={rationale}>
      <span>{badge}</span>
    </Tooltip>
  );
}
